import styled from "styled-components";

export const StyledWrapper = styled.div`
  ${({ theme }) => theme.fontStyles.DesktopCopySmallBold}
  ${({ theme }) => theme.media.exceptSmallMobile`
    font-size: 14px;
  `}

  .breadcrumb-item a {
    color: ${({ theme }) => theme.colors.neutralsTextDisabled};
  }
`;
